import { useNavigate } from 'react-router-dom'
import { useModal } from '../../hooks/use-modal-store'
import FullPagePopupLayout from './FullPagePopupLayout'

const AdminPopup = () => {
  const { isOpen, onClose, type, data } = useModal()
  const navigate = useNavigate()

  const isModalOpen = isOpen && type === 'openAdminPopup'
  const adminPlanPath =
    '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/addPlan'
  const stayOnPage = Boolean(data?.stayOnPage)
  const secondaryLabel = data?.secondaryLabel || 'User Plans'
  const secondaryPath = data?.secondaryPath || adminPlanPath

  const handleClose = () => {
    onClose()
    if (!stayOnPage) navigate(adminPlanPath)
  }

  const handleSecondary = () => {
    onClose()
    navigate(secondaryPath)
  }

  return (
    <FullPagePopupLayout
      isOpen={isModalOpen}
      onClose={onClose}
      severity={data?.severity || 'notice'}
      title={data?.title || 'Admin action complete'}
      message={data?.message}
      actions={
        <>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-secondary'
            onClick={handleClose}
          >
            Close
          </button>
          <button
            type='button'
            className='fabits-global-popup-button fabits-global-popup-button-primary'
            onClick={handleSecondary}
          >
            {secondaryLabel}
          </button>
        </>
      }
    />
  )
}

export default AdminPopup
